import * as yup from 'yup';
import docs from './attachments/specific';
import {
  acessoContraCheque,
  // acessoJornalForluz,
  adiantamentoQuinzenal,
  consentimentoDadosSensiveis,
  consentimentoDescontoFolha,
  cpfResponsavelLegal,
  medicos,
  nomeDoTutor,
  parentesco,
  aceiteInss,
  declaracaoVeracidade,
  consentimentoAcertoFinanceiro,
} from './utils/rulesByKey';

export const rcmbSchema = yup.object({
  ...parentesco,
  ...nomeDoTutor,
  ...medicos('medicoPerito'),
  ...medicos('medicoAssistente'),
  ...adiantamentoQuinzenal,
  ...acessoContraCheque,
  // ...acessoJornalForluz,
  ...consentimentoDadosSensiveis(),
  ...consentimentoDescontoFolha,
  ...declaracaoVeracidade,
  ...consentimentoAcertoFinanceiro,
  ...cpfResponsavelLegal,
  ...aceiteInss,
  ...docs.RCMBDocs.rules,
});

export const rcmbInitialValues = {
  parentesco: '',
  nomeDoTutor: '',
  medicoPerito: '',
  medicoAssistente: '',
  adiantamentoQuinzenal: '',
  acessoContraCheque: '',
  // acessoJornalForluz: '',
  consentimentoDadosSensiveis: false,
  consentimentoDescontoFolha: false,
  declaracaoVeracidade: false,
  consentimentoAcertoFinanceiro: false,
  aceiteInss: false,
  cpfResponsavelLegal: '',
  ...docs.RCMBDocs.initialValues,
};

export const rcmbDocs = {
  ...docs.RCMBDocs.docs,
};
